import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
} from '@mui/material';

export const EventPlanModal = ({
  title,
  isOpen,
  onClose,
  onSubmit,
  children,
}: {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <DialogTitle
          sx={{
            padding: '20px',
            boxShadow: '0px -1px 0px 0px rgba(0, 0, 0, 0.10) inset',
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ padding: '0 20px' }}>
          {children}
          <Divider sx={{ margin: '0' }} />
        </DialogContent>
        <DialogActions>
          <Button variant="text" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="secondary" onClick={onSubmit}>
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
